import React from "react";
import Testimonials from "./TestimonialsCards";
import "../../styles/TestimonialsSection/TestimonialsSection.scss";
import { TestimonialsHeader } from "./TestimonialsHeader";
import { useTranslation } from "react-i18next";

export const TestimonialsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="TestimonialsSection" id="TestimonialsSection">
      <p>{t("testimonials")}</p>
      <TestimonialsHeader />
      <Testimonials />
    </section>
  );
};
